"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWaybackItemByReleaseNumber = exports.getWaybackItems = exports.getWaybackConfigData = void 0;
const config_1 = require("../config");
const waybackItem_1 = require("../helpers/waybackItem");
/**
 * World Imagery Wayback configuration data, encompassing information
 * about all releases. It utilizes the release number as the primary key for retrieval.
 */
let waybackconfig = null;
/**
 * An array containing data related to all World Imagery Wayback releases.
 * This array is sorted in descending order based on the release date.
 */
let waybackItems = null;
/**
 * A Map that will be used to efficiently
 * retrieve wayback items by their release numbers.
 */
let waybackItemByReleaseNumber = null;
/**
 * Get Wayback Configuration file that provides information about all World Imagery Wayback releases.
 * This function retrieves the Wayback Configuration data asynchronously, caching it for subsequent calls.
 * @returns {Promise<WaybackConfig>} A Promise resolving to the Wayback Configuration data.
 */
const getWaybackConfigData = () => __awaiter(void 0, void 0, void 0, function* () {
    // // Check if waybackconfig data is already available; return cached data if present
    if (waybackconfig) {
        return waybackconfig;
    }
    const url = (0, config_1.getWaybackConfigFileURL)();
    const res = yield fetch(url);
    if (!res.ok) {
        throw new Error('failed to fetch wayback config file');
    }
    // Parse the fetched JSON response as WaybackConfig and cache it for subsequent calls
    waybackconfig = (yield res.json());
    return waybackconfig;
});
exports.getWaybackConfigData = getWaybackConfigData;
/**
 * Get an array of data for all World Imagery Wayback releases/versions.
 *
 * This function retrieves an array of Wayback items from the Wayback Configuration data,
 * sorting them by release date in descending order (newset release is the first item) and caching the result for subsequent calls.
 *
 * @returns {Promise<WaybackItem[]>} A Promise resolving to an array of Wayback items.
 */
const getWaybackItems = () => __awaiter(void 0, void 0, void 0, function* () {
    if (waybackItems) {
        return waybackItems;
    }
    const waybackConfig = yield (0, exports.getWaybackConfigData)();
    waybackItems = Object.keys(waybackConfig).map((key) => {
        const releaseNum = +key;
        const waybackconfigItem = waybackconfig[releaseNum];
        if (!waybackconfig[releaseNum]) {
            return null;
        }
        const { itemTitle } = waybackconfigItem;
        // Extract release date details from the Wayback item title using a helper function
        const { releaseDateLabel, releaseDatetime } = (0, waybackItem_1.extractDateFromWaybackItemTitle)(itemTitle) || {};
        const waybackItem = Object.assign({ releaseNum,
            releaseDateLabel,
            releaseDatetime }, waybackconfigItem);
        return waybackItem;
    });
    // Remove null entries and sort the Wayback items by releaseDatetime (descending order)
    waybackItems = waybackItems
        .filter((item) => item !== null)
        .sort((a, b) => {
        return b.releaseDatetime - a.releaseDatetime;
    });
    return waybackItems;
});
exports.getWaybackItems = getWaybackItems;
/**
 * Retrieves a specific World Imagery Wayback item based on the provided release number.
 * It utilizes a Map named waybackItemByReleaseNumber to efficiently
 * retrieve wayback items by their release numbers.
 *
 * @param releaseNumber The release number of the wayback item to retrieve
 * @returns A Promise that resolves with the wayback item corresponding to the provided release number.
 *          If the wayback item for the given release number is not found, it returns undefined.
 */
const getWaybackItemByReleaseNumber = (releaseNumber) => __awaiter(void 0, void 0, void 0, function* () {
    if (!waybackItemByReleaseNumber) {
        const waybackItems = yield (0, exports.getWaybackItems)();
        waybackItemByReleaseNumber = new Map();
        // save wayback items to the `waybackItemByReleaseNumber` map
        for (const waybackItem of waybackItems) {
            waybackItemByReleaseNumber.set(waybackItem.releaseNum, waybackItem);
        }
    }
    return waybackItemByReleaseNumber.get(releaseNumber);
});
exports.getWaybackItemByReleaseNumber = getWaybackItemByReleaseNumber;
//# sourceMappingURL=index.js.map